// Local banner images
import fastfood1 from "@assets/images/scan-to/banners/fastfood_1.jpg";
import fastfood2 from "@assets/images/scan-to/banners/fastfood_2.jpg";
import restaurant1 from "@assets/images/scan-to/banners/restaurant_1.jpg";
import restaurant2 from "@assets/images/scan-to/banners/restaurant_2.jpg";
import cafe1 from "@assets/images/scan-to/banners/cafe_1.jpg";
import cafe2 from "@assets/images/scan-to/banners/cafe_2.jpg";
import hotel1 from "@assets/images/scan-to/banners/hotel_1.jpg";
import hotel2 from "@assets/images/scan-to/banners/hotel_2.jpg";
import camping1 from "@assets/images/scan-to/banners/camping_1.jpg";
import camping2 from "@assets/images/scan-to/banners/camping_2.jpg";

// ─── Default banner translations (multilingual) ─────────
export const DEFAULT_TRANSLATIONS: Record<
    string,
    { title: string; description: string }
> = {
    fr: {
        title: "Bienvenue à notre restaurant !",
        description: "Découvrez, commandez et savourez vos repas.",
    },
    en: {
        title: "Welcome to our restaurant!",
        description: "Discover, order and enjoy your meals.",
    },
    ru: {
        title: "Добро пожаловать в наш ресторан!",
        description: "Откройте для себя, закажите и насладитесь едой.",
    },
    it: {
        title: "Benvenuti nel nostro ristorante!",
        description: "Scopri, ordina e goditi i tuoi pasti.",
    },
    es: {
        title: "¡Bienvenido a nuestro restaurante!",
        description: "Descubre, pide y disfruta de tus comidas.",
    },
    pt: {
        title: "Bem-vindo ao nosso restaurante!",
        description: "Descubra, peça e saboreie suas refeições.",
    },
    de: {
        title: "Willkommen in unserem Restaurant!",
        description: "Entdecken, bestellen und genießen Sie Ihre Mahlzeiten.",
    },
    ar: {
        title: "!مرحبا بكم في مطعمنا",
        description: ".اكتشف واطلب واستمتع بوجباتك",
    },
};

export { LANGUAGE_CODES } from "../shared/constants";

// ─── Banner images for each activity (2 images per activity) — local assets ─
export const ACTIVITY_BANNER_IMAGES: Record<string, string[]> = {
    fastfood: [fastfood1, fastfood2],
    traditional_restaurant: [restaurant1, restaurant2],
    cafe: [cafe1, cafe2],
    hotel: [hotel1, hotel2],
    camping: [camping1, camping2],
};
